import isEmpty from 'lodash/isEmpty';
import { createSelector } from 'reselect';

import { AppState } from 'src/config/appState';

import { getCPProgramState } from '../../selectors/cpProgramSelectors';

export const getHomeworkConfidenceRating = (state: AppState): number =>
    getCPProgramState(state).homeworkConfidenceRating;

export const isHomeworkConfidenceRatingValid = createSelector(
    getHomeworkConfidenceRating,
    (value): boolean => value > 0,
);

export const getValuesAssessments = (state: AppState) => getCPProgramState(state).valuesAssessments;

export const isValuesAssessmentsDataValid = createSelector(
    getValuesAssessments,
    (assessmentAreas): boolean =>
        !assessmentAreas.find(
            area => (isEmpty(area.topics) && area.additionalInfo === '') || area.rate === 0,
        ),
);

export const getValuesAssessmentsAreasAdditionalRatePoints = (state: AppState): number =>
    getCPProgramState(state).valuesAssessments.reduce((acc, area) => acc + area.additionalRate, 0);
